import React from 'react';
import { defineMessages } from 'react-intl';
import { MultilingualWidget } from 'volto-multilingual-widget';
import {
  ArrayWidget,
  ColorPickerWidget,
  ObjectListWidget,
} from '@plone/volto/components';
import {
  SizeWidget,
  ColorListWidget,
} from '@redturtle/iovisit-theme/components';
import { VocabularyIconsWidget } from 'volto-vocabulary-icons-widget';
import contactsSchema from '@redturtle/iovisit-theme/helpers/contactsSchema';

const messages = defineMessages({
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
  transparent: {
    id: 'transparent',
    defaultMessage: 'Trasparente',
  },
});

export const IoVisitWidgets = (config) => {
  config.widgets.id.cookie_consent_configuration = MultilingualWidget();
  config.widgets.id.thematic_areas = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.cuisine_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );

  config.widgets.id.custom_transports = MultilingualWidget(
    (props) => <VocabularyIconsWidget {...props} wrapped={false} />,
    [],
  );
  config.widgets.id.restaurant_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.accomodation_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.suited_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.service_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );

  config.widgets.id.cta_background_color = (props) => {
    return (
      <ColorPickerWidget
        {...props}
        colors={[
          {
            name: 'primary',
            label: props.intl.formatMessage(messages.primary),
          },
          {
            name: 'secondary',
            label: props.intl.formatMessage(messages.secondary),
          },
          {
            name: 'tertiary',
            label: props.intl.formatMessage(messages.tertiary),
          },
          { name: 'white', label: props.intl.formatMessage(messages.white) },
        ]}
      />
    );
  };

  config.widgets.id.cta_button_color = (props) => {
    return (
      <ColorPickerWidget
        {...props}
        colors={[
          {
            name: 'primary',
            label: props.intl.formatMessage(messages.primary),
          },
          {
            name: 'secondary',
            label: props.intl.formatMessage(messages.secondary),
          },
          {
            name: 'tertiary',
            label: props.intl.formatMessage(messages.tertiary),
          },
          { name: 'white', label: props.intl.formatMessage(messages.white) },
          {
            name: 'transparent',
            label: props.intl.formatMessage(messages.transparent),
          },
        ]}
      />
    );
  };

  config.widgets.id.phone_contacts = (props) => {
    return (
      <div className="contacts-widget">
        <ObjectListWidget {...props} schema={contactsSchema(props)} />
      </div>
    );
  };

  config.widgets.id.link_contacts = (props) => {
    return (
      <div className="contacts-widget">
        <ObjectListWidget {...props} schema={contactsSchema(props)} />
      </div>
    );
  };

  //(props) => <VocabularyWidget {...props} wrapped={false} />, //per quelli di tipo chiave-valore
  config.widgets.type.size = SizeWidget;
  config.widgets.widget.color_list = ColorListWidget;
};
